// extracted by mini-css-extract-plugin
export var fadeInSection = "FadeInSection-module--fade-in-section--NSALp";
export var isVisible = "FadeInSection-module--is-visible--zSrBE";